import { Modal } from "@joonapp/web-shared"
import { ModalHeader } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useDoterChatStore } from "./useDoterChatStore"
import DoterChatHistory from "../manageGameplay/doterChat/DoterChatHistory"

const DoterChatModal = () => {
  const { isOpen, onClose } = useDoterChatStore()
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      mobileFull
      style={{ width: "min(500px, 100vw)" }}
      animate
    >
      <ModalHeader
        title={t("DC_ALL_CONVERSATIONS")}
        onClose={onClose}
        showBorderBottom
      />

      <DoterChatHistory />
    </Modal>
  )
}

export default DoterChatModal
